<script setup>
import { inject } from 'vue';

const p = inject('primaryColor')
</script>

<template>
  <router-view :style="`--color-theme-primary: ${p}`"/>
</template>